module.exports = __webpack_public_path__ + "img/ApprTemp6.129ef49c.png";